<template>
  <div v-if="max > 0" v-show="!ispc" id="c-relatedSp" class="c-relatedSp">

    <transition name="c-relatedSp__bg">
    <span v-show="isShowRelatedSp" class="c-relatedSp__bg" @click="closeRelated"></span>
    </transition>

    <div class="c-relatedSp__wrap">
      <div ref="parentCircle" class="c-relatedSpCircle c-relatedSpCircle--sp c-relatedSpCircle--parent" @click="openRelated">
        <div class="c-relatedSpCircle__lines">
          <div v-for="(c, index) in params.child" ref="childLine" :key="index" class="c-relatedSpCircle__linesChild"><div></div></div>
        </div>

        <div class="c-relatedSpCircle__bg js-hoverBg">
          <svg class="c-relatedSpCircle__bgMain js-hoverBgMain" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedSpCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedSpCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
        </div>

        <div class="c-relatedSpCircle__photo js-hoverPhoto">
          <div v-if="params.parent.img" class="c-relatedSpCircle__photoInner" :style="`background-image: url(${params.parent.img});`"></div>
          <div v-if="!params.parent.img" class="c-relatedSpCircle__photoInner c-relatedSpCircle__photoInner--noimg"></div>
        </div>
        <div class="c-relatedSpCircle__text">
          <p class="f-ITC-BoldIt" v-html="params.parent.title"></p>
        </div>
        <div v-show="!isShowRelatedSp" class="c-relatedSpCircle__hold f-ITC-BoldIt">TAP</div>
      </div>

      <a v-for="(c, index) in params.child" ref="childCircle" :key="index" class="c-relatedSpCircle c-relatedSpCircle--child" :href="c.url">
        <div class="c-relatedSpCircle__bg js-hoverBg">
          <svg class="c-relatedSpCircle__bgMain js-hoverBgMain" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedSpCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
          <svg class="c-relatedSpCircle__bgHover js-hoverBgHover" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240">
            <circle cx="120" cy="120" r="115" />
          </svg>
        </div>

        <div class="c-relatedSpCircle__photo js-hoverPhoto">
          <div v-if="c.img" class="c-relatedSpCircle__photoInner" :style="`background-image: url(${c.img});`"></div>
          <div v-if="!c.img" class="c-relatedSpCircle__photoInner c-relatedSpCircle__photoInner--noimg"></div>
        </div>

        <div class="c-relatedSpCircle__text">
          <p class="f-ITC-BoldIt" v-html="c.title"></p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import ResizeObserver from 'resize-observer-polyfill';
  import { assets_path, breakpoint } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';
  import {TweenMax, Cubic} from 'gsap/all';
  import hoverRelated from '@/_modules/common/hoverRelated';

  export default {
    data() {
      return {
        assets_path: assets_path,
        ispc: false,
        isShow: false,
        params: {},
        max: 0,
        center: {
          x: 0,
          y: 0
        },
        positions: [],
        parentHover: null,
        hovers: [],
        rectParent: {},
        rectChild: {},
        sizeParent: 300,
        sizeChild: 200,
        maxDistanceX: 0,
        maxDistanceY: 0,
        wrapper: null
      }
    },
    store,
    watch: {
      isShowRelatedSp (val) {
        if (val) {
          // open
          //this.resize();
        } else {
          // close
          this.reset();
        }
      }
    },
    computed: {
      isShowRelatedSp: function () {
        return this.$store.getters.isShowRelatedSp;
      }
    },
    created() {

    },
    mounted() {
      this.params = JSON.parse(document.getElementById('js-param-related').textContent);
      this.max = this.params.child.length;
      this.wrapper = document.getElementById('c-wrapper');

      this.$nextTick(this.start);
    },
    methods: {
      openRelated() {
        if (this.$store.getters.isShowRelatedSp) return;

        this.$store.commit('setShowRelatedSp', true);

        this.showChild();

        // hold /////

        //document.body.style.position = 'fixed';

        //this.$el.addEventListener('mousemove', this.moveOperation);

        //////////
      },
      closeRelated() {
        if (!this.$store.getters.isShowRelatedSp) return;

        // hold /////

        //document.body.style.position = '';

        //this.$el.removeEventListener('mousemove', this.moveOperation);

        //////////

        this.$store.commit('setShowRelatedSp', false);

        this.hideChild();
      },

      onResizeObserver(entries) {
        this.resize();
      },

      // 初期表示 /////
      start() {
        // オブザーバインスタンスを作成
        this.observer = new ResizeObserver(this.onResizeObserver);
        this.observer.observe(this.wrapper);

        this.setting();
        this.showInit();
      },
      showInit() {
        // 親）円を配置
        this.parentHover = new hoverRelated(this.$refs['parentCircle'], 0, this.center, false);
        this.parentHover.start();

        // 子）円を配置
        this.$refs['childCircle'].forEach((el, index) => {
          this.hovers[index] = new hoverRelated(el, index, this.center, this.positions[index], false);
        });

        //window.addEventListener('resize', this.resize);
      },

      // 子表示 /////
      showChild() {
        for (let i = 0; i < this.max; i++) {
          // 初期の角度
          const degree = this.initDegree(i);

          // 楕円形に配置（座標を求める）
          let ovalPosition = this.$_getOvalPosition(
            degree,
            this.$_random(this.rectParent.width * 0.85, this.maxDistanceX),
            this.maxDistanceY * this.$_random(1, 1.3),
            this.center.x,
            this.center.y
          );

          // 各円の数値（角度は計算後に反転している）
          const position = {
            degree: 180 + this.$_rad2deg(this.$_pos2radian(ovalPosition, this.center)),
            distance: this.$_pos2dist(ovalPosition, this.center),
            x: ovalPosition.x,
            y: ovalPosition.y
          };

          // 円の数値を配列にする
          this.positions[i] = position;

          // 縁を結ぶライン
          TweenMax.set(this.$refs['childLine'][i], {
            visibility: 'visible',
            rotate: position.degree,
            width: position.distance
          });

          TweenMax.set(this.$refs['childLine'][i].querySelector('div'), {
            x: -position.distance
          });
        }

        this.showComp();
      },
      showComp() {
        this.parentHover.start(false);

        this.hovers.forEach((h, i) => {
          h.start(true, this.positions[i]);

          TweenMax.to(this.$refs['childLine'][i].querySelector('div'), 0.4, {
            delay: 0.02 * i,
            x: 0
          });
        });
      },
      hideChild() {
        this.hovers.forEach((h, i) => {
          h.hide(true, this.positions[i]);

          TweenMax.to(this.$refs['childLine'][i].querySelector('div'), 0.3, {
            //delay: 0.1 * i,
            x: -this.positions[i].distance
          });
        });
      },

      setting() {
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
        } else {
          this.ispc = false;
        }

        const winW = this.$_getBodyWidth();
        const top = (512 / 750) * winW;
        this.rectParent = {
          height: (this.sizeParent / 750) * winW,
          width: (this.sizeParent / 750) * winW
        };

        if (!this.ispc) {

          this.center = {
            x: 0,
            y: this.$_getOffset(document.getElementById('c-related')).top + top + (this.rectParent.width * 0.5)
          };

          this.rectChild = {
            height: (this.sizeChild / 750) * winW,
            width: (this.sizeChild / 750) * winW
          };

          this.maxDistanceX = this.maxDistanceY = (Math.min(winW, window.innerHeight) - this.rectChild.width) * 0.5;
        }
      },
      moveOperation(e) {
        console.log(e);

        if (e.type === 'mousemove') {
          // mousemove
          console.log(e.type, e.pageX, e.pageY);
        } else {
          // touchmove
          //console.log(e.type, e.pageX, e.pageY);
        }

        console.log(document.elementFromPoint(e.pageX, e.pageY));
      },
      setPosition() {
        //
        //  角度、距離設定
        //
        /*
        if (!this.ispc) {
          for (let i = 0; i < this.max; i++) {
            // 初期の角度
            const degree = this.initDegree(i);

            // 楕円形に配置（座標を求める）
            let ovalPosition = this.$_getOvalPosition(
              degree,
              this.$_randomInt(this.rectParent.width * 0.85, this.maxDistanceX),
              this.maxDistanceY * this.$_randomInt(1, 1.2),
              this.center.x,
              this.center.y
            );

            // 各円の数値（角度は計算後に反転している）
            const position = {
              degree: 180 + this.$_rad2deg(this.$_pos2radian(ovalPosition, this.center)),
              distance: this.$_pos2dist(ovalPosition, this.center),
              x: ovalPosition.x,
              y: ovalPosition.y
            };

            this.positions[i] = position;

            TweenMax.set(this.$refs['childLine'][i], {
              rotate: position.degree,
              width: position.distance
            });
          }

          // 親）
          this.parentHover.resize(this.center);

          // 子）円の位置再設定
          this.hovers.forEach((h, index) => {
            h.resize(this.center, this.positions[index]);
          });
        }*/

        // 親）
        this.parentHover.resize(this.center);

        // 子）円の位置再設定
        this.hovers.forEach((h, index) => {
          h.resize(this.center, this.positions[index]);
        });
      },
      resize() {
        this.closeRelated();

        // 数値リセット
        this.setting();

        // 円の位置を再設定
        this.setPosition();
      },

      initDegree(i) {
        return -20 + ((360 / this.max) * i) - this.$_randomInt(-15, 15);
      },
      reset() {

      },
      /*
      imgloaded(e) {
        if (e.target.naturalWidth  / e.target.naturalHeight > 1) {
          e.target.style.height = '100%';
          e.target.style.width = 'auto';
        } else {
          e.target.style.height = 'auto';
          e.target.style.width = '100%';
        }
      }*/
    }
  }
</script>
